import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('google/classroom/wholeClass/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    type: "wholeClass"
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/classroom/wholeClass/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    selectedIds,
    RestoreType,
    type: "wholeClass"
  }, {code: code ? code : null})
}

export {
  exportSnapshot,
  restoreSnapshot,
}
